import React, { useEffect, useState } from 'react';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import './styles.css';
import { useSelector, useDispatch } from 'react-redux';
import { desautenticarUsuario } from '../../../store/modules/autenticacao/actions';
import historico from '../../../services/Historico';
import itens from './itens';
import { Link, useRouteMatch } from 'react-router-dom';

export default function Menu(props) {
  let match = useRouteMatch();
  const [expanded, setMenuExpanded] = useState(true);
  const [mobile, setMobile] = useState(() => window.matchMedia('(max-width: 767px)').matches);
  const [drawerAberto, setDrawerAberto] = useState(false);
  const [perfilAberto, setPerfilAberto] = useState(false);
  const menuAberto = mobile ? drawerAberto : expanded;
  const dispatch = useDispatch();
  const usuario = useSelector((state) => {
    return state.usuario;
  });

  // const redesAntifraude = useSelector((state) => {
  //   return state.autenticacao.redesAntifraude;
  // });

  const sair = () => {
    setDrawerAberto(false);
    dispatch(desautenticarUsuario());
  };

  const perfil = () => {
    setDrawerAberto(false);
    historico.push('/painel/perfil');
  };

  useEffect(() => {
    const media = window.matchMedia('(max-width: 767px)');
    const atualizar = () => setMobile(media.matches);
    if (media.addEventListener) media.addEventListener('change', atualizar);
    else media.addListener(atualizar);
    return () => {
      if (media.removeEventListener) media.removeEventListener('change', atualizar);
      else media.removeListener(atualizar);
    };
  }, []);

  useEffect(() => {
    const conteudo = document.querySelector('.main-painel');
    if (!conteudo) return;
    conteudo.style.paddingLeft = mobile ? '10px' : expanded ? '250px' : '74px';
    conteudo.style.paddingTop = mobile ? '66px' : '10px';
  }, [expanded, mobile]);

  useEffect(() => {
    if (!mobile) setDrawerAberto(false);
  }, [mobile]);

  useEffect(() => {
    if (!mobile || !drawerAberto) return;
    const fecharComEscape = (event) => {
      if (event.key === 'Escape') setDrawerAberto(false);
    };
    document.addEventListener('keydown', fecharComEscape);
    return () => document.removeEventListener('keydown', fecharComEscape);
  }, [mobile, drawerAberto]);

  return (
    <>
    {mobile && (
      <header className="menu-painel-mobile">
        <button
          type="button"
          className="menu-painel-mobile-botao"
          onClick={() => setDrawerAberto(!drawerAberto)}
          aria-expanded={drawerAberto}
          aria-controls="menu-painel-navegacao"
          aria-label={drawerAberto ? 'Fechar menu' : 'Abrir menu'}
        >
          <i className={`fas ${drawerAberto ? 'fa-chevron-left' : 'fa-bars'}`} aria-hidden="true" />
          <span>Menu</span>
        </button>
        <img
          className="menu-painel-mobile-logo"
          src="/imagens/logo-fundo-escuro.png"
          alt="Clube Pro Pintor"
        />
      </header>
    )}
    {mobile && drawerAberto && (
      <button
        type="button"
        className="menu-painel-overlay"
        onClick={() => setDrawerAberto(false)}
        aria-label="Fechar menu"
      />
    )}
    <SideNav
      id="menu-painel-navegacao"
      className="position-fixed menu-painel"
      expanded={menuAberto}
      onSelect={(item, evento) => {
        if (mobile) setDrawerAberto(false);
        props.selecionarItem(item, evento);
      }}
      onToggle={setMenuExpanded}
    >
      {!mobile && <SideNav.Toggle
        className="nav-toggle"
        aria-label={expanded ? 'Recolher menu' : 'Expandir menu'}
        title={expanded ? 'Recolher menu' : 'Expandir menu'}
      >
        <i className={`fas fa-chevron-${expanded ? 'left' : 'right'}`} aria-hidden="true" />
      </SideNav.Toggle>}
      {(!mobile || menuAberto) && (
        <img
          id="logo-nav"
          src="/imagens/logo-fundo-escuro.png"
          alt="Logo Clube Pro Pintor"
        />
      )}
      <SideNav.Nav>
        {menuAberto && (
          <div id="perfil">
            <span className="nav-font nav-titulo nome-usuario">
              Olá, <b>{usuario.nome}</b>
              {perfilAberto ? (
                <button
                  onClick={(e) => setPerfilAberto(false)}
                  className="btn-limpo"
                  aria-label="Recolher opções do perfil"
                >
                  <i className="fas fa-angle-double-up"></i>
                </button>
              ) : (
                <button
                  onClick={(e) => setPerfilAberto(true)}
                  className="btn-limpo"
                  aria-label="Mostrar opções do perfil"
                >
                  <i className="fas fa-angle-double-down"></i>
                </button>
              )}
            </span>
            {perfilAberto && (
              <>
                <button onClick={perfil} className="nav-sub-titulo">
                  Meu Perfil
                </button>
                <button onClick={sair} className="nav-sub-titulo">
                  Sair
                </button>
              </>
            )}
          </div>
        )}
        {itens.map((item) =>
          item.permissao.includes(usuario.permissao) ? (
            <NavItem eventKey={item.destino} key={item.destino}>
              <NavIcon>
                {item.subItens ? (
                  <span className="nav-font">
                    <i className={item.icone} />
                  </span>
                ) : (
                  <Link to={`${match.path}${item.destino}`}>
                    <i className={item.icone} />
                  </Link>
                )}
              </NavIcon>
              <NavText>
                {item.subItens ? (
                  <span className="nav-font">{item.titulo}</span>
                ) : (
                  <Link
                    to={`${match.path}${item.destino}`}
                    className="nav-font w-100 h-100 d-inline-block"
                  >
                    {item.titulo}
                  </Link>
                )}
                {/* {item.titulo === 'Antifraude' && redesAntifraude.length > 0 && (
                  <span className="alert-antifraude">
                    {redesAntifraude.length}
                  </span>
                )} */}
              </NavText>
              {item.subItens &&
                item.subItens.map(
                  (subitem) =>
                    subitem.permissao.includes(usuario.permissao) && (
                      <NavItem
                        eventKey={`${item.destino}${subitem.destino}`}
                        key={`${item.destino}${subitem.destino}`}
                      >
                        <NavText>
                          <Link
                            to={`${match.path}${item.destino}${subitem.destino}`}
                            className="nav-font w-100 h-100 d-inline-block"
                          >
                            {subitem.titulo}
                          </Link>
                        </NavText>
                      </NavItem>
                    )
                )}
            </NavItem>
          ) : null
        )}
      </SideNav.Nav>
    </SideNav>
    </>
  );
}
